module.exports = __webpack_public_path__ + "img/titulo-tags.6dd2dca4.png";